import {Dialog} from '@base-ui/react/dialog';
import cn from 'clsx';
import type {ReactNode} from 'react';

const getRootElement = () => document.getElementById('root');

interface PopupProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    className?: string;
    'aria-labelledby'?: string;
    children: ReactNode;
}

const Popup = ({open, onOpenChange, className, 'aria-labelledby': ariaLabelledBy, children}: PopupProps) => (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
        {/* state/ducks/uwm.ts toggles .dark on #root, so a portal to document.body would drop every dark: variant. */}
        <Dialog.Portal container={getRootElement()}>
            <Dialog.Popup
                aria-labelledby={ariaLabelledBy}
                className={cn(
                    'fixed inset-0 z-100 animate-slide-from-right overflow-y-auto bg-secondary dark:bg-orion-1',
                    className
                )}
            >
                {children}
            </Dialog.Popup>
        </Dialog.Portal>
    </Dialog.Root>
);

export default Popup;
